import React, {useState} from "react";
import useEditableTableTextAreaCell from "../../hooks/useEditableTableTextAreaCell";
import {Button, Form} from "react-bulma-components";
import useEditableTableCostCell from "../../hooks/useEditableTableCostCell";


export default function WeeklyTransactionRow({value, onChange, onSave, index, typeMapping, onDelete}){
    const [editable, setEditable] = useState(false);

    const handleChange = e => {
        let newTransaction = {...value, [e.target.name]: e.target.value};
        onChange(index, newTransaction);
    }

    const handleCheck = e => {
        let newTransaction = {...value, [e.target.name]: e.target.checked};
        onChange(index, newTransaction);
    }

    const handleSave = () => {
        onSave(false, value);
        setEditable(false);
    }


    return (
        <tr style={{ fontSize: 12 }} key={value.id}>
              <td>{value.description}</td>
              <td>{value.frequency}</td>
              <td>{value.contact ? value.contact.display_name : ""}</td>
              <td>{value.department ? value.department.name : ""}</td>
              <td>{typeMapping[value.type]}</td>
              {useEditableTableTextAreaCell({
                propName: "comments",
                value: value.comments,
                editable,
                setEditable,
                inlineEdit: true,
                onChange: handleChange,
                onSave: handleSave
              })}
              <td>
                  <Form.Checkbox
                    checked={value.ignore_in_figures}
                    onChange={handleCheck}
                    name={"ignore_in_figures"}
                    disabled={!editable}
                  />
              </td>
             {useEditableTableCostCell({
                 propName: "amount",
                 value: value.amount,
                 editable,
                 setEditable,
                 inlineEdit: true,
                 onChange: handleChange,
                 onSave: handleSave
             })}
              <td className={"is-narrow"}>
                <Button
                  color={"danger"}
                  onClick={() => {
                    onDelete(value.id);
                  }}
                >
                  Delete X
                </Button>
              </td>
        </tr>
    )



}